<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Title" required="true" placeholder="i.e How to use this website?" />
                    <select-input v-model="form.cat_id" :error="form.errors.cat_id" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Category" required="true">
                        <option :value=null>Select Category</option>
                        <option v-for="faqItem in faqCat" :key="faqItem.id" :value='faqItem.id'>{{ faqItem.title }}
                        </option>
                    </select-input>
                    <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Category" required="true">
                        <option :value=null>Select Content Type</option>
                        <option value='content'>Content</option>
                        <option value='image'>Image</option>
                        <option value='pdf'>Pdf</option>
                        <option value='video'>Video</option>
                    </select-input>
                    <template v-if="form.type == 'image' || form.type == 'pdf'">
                        <div class="mt-1 flex pb-8 pr-6 w-full lg:w-1/1 items-center">
                            <div
                                class="mt-1 flex flex-wrap justify-center rounded-md border-2 border-dashed border-gray-300 dark:border-black dark:bg-white dark:text-black px-6 pt-5 pb-6">
                                <div class="space-y-1 text-center">
                                    <PhotoBlock :getPhoto="form.attachment" @SetPhoto="set_photo" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="form.type == 'video'">
                        <div class="pb-8 pr-6 w-full lg:w-1/1">
                            <text-input v-model="form.embed_url" :error="form.errors.embed_url"
                                class="pb-8 pr-6 w-full lg:w-1/1" label="Embed Code" required="true"
                                placeholder="i.e https://www.youtube.com/watch?v=P-I4Bay5SXo" />
                        </div>
                    </template>
                    <template v-else-if="form.type == 'content'">
                        <div class="pb-8 pr-6 w-full lg:w-1/1">
                            <label class="form-label" for="description">Description<span
                                    class="custom-error">*</span></label>
                            <vue-editor v-model="form.description" />
                        </div>
                    </template>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="pb-8 pr-6 w-full lg:w-1/1"></status-toogle-button>
                </div>
                <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextInput from '@/Shared/TextInput'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject } from 'vue'
import { Quill, VueEditor } from "vue3-editor"
import PhotoBlock from './Photo';
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        Quill,
        VueEditor,
        PhotoBlock
    },
    layout: Layout,
    remember: 'form',
    props: {
        faqCat: Array
    },
    setup(props) {
        const { faqCat } = toRefs(props)
        const form = useForm({
            title: null,
            description: null,
            status: true,
            cat_id: null,
            type: null,
            embed_url: null,
            attachment: null
        })
        const type = ref('create')
        const title = ref('FAQ')
        const url = ref('/backend/faqs')
        const createUrl = ref('')
        const swal = inject('$swal')
        const set_photo = (val) => {
            form.attachment = val
        }
        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your infomation has been Added.',
                        'success'
                    )
                }
            });

        }
        return {
            form,
            type,
            title,
            url,
            createUrl,
            store,
            faqCat,
            set_photo
        }
    }
}
</script>
